"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/exports/StyleSheet"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _StyleSheet.default.create({
  contentContainer: {
    width: '100%',
    height: '100%'
  }
});

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/alerts/AlertContainer/styles.js
// module id = ./node_modules/quark-web/components/alerts/AlertContainer/styles.js
// module chunks = 0